import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { ButtonLinkComponent } from '@mode/capra';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';

@Component({
  standalone: true,
  selector: 'mode-report-clone-success',
  imports: [ButtonLinkComponent, SharedUtilToastModule],
  templateUrl: './report-clone-success.component.html',
  styleUrls: ['./report-clone-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ReportCloneSuccessComponent extends Toast {
  clonedReportLink = this.options.payload.clonedReportLink;

  dismissToast() {
    this.remove();
  }
}
